import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { deleteadminlist, subadminlist } from "../../service/Mainservice";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Alert, Snackbar } from "@mui/material";
import Loader from "../../Loader/Loader";
import Pagination from "../Pagination/pagination";
import moment from "moment";
import Deletepopup from "../Vendor/Aresure";

const SubAdminList = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [addinterview, setaddinterview] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [id, setid] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterror] = useState("");
  const [pagination, setpagination] = useState({ page: 1 });

  const navigate = useNavigate();

  useEffect(() => {
    getData("1");
  }, []);

  const getData = async (value) => {
    try {
      const response = await subadminlist(value);
      console.log(response);
      setData(response.data.data);
      setpagination(response.data.pagination);

      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    getData(pageNumber);
  };

  // const handlesearch = async (e) => {
  //   setsearchvalue(e.target.value);
  //   getData(1, e.target.value);
  // };

  const handledelete = async () => {
    try {
      const response = await deleteadminlist(id);
      getData("1");
      setshowdelete(false);
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
      setshowdelete(false);
    }
  };

  const onClose = () => {
    setshowdelete(false);
    // navigate("/Room");
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">All Editor List</h1>
          <div className="data_headdown">
            <h1 className="data_add" onClick={() => navigate("/Add_Editors")}>
              <AddIcon /> Add Editors
            </h1>

            {/* <div className="searchicon">
              <SearchIcon />
              <input
                type="search"
                placeholder="Search..."
                id="search"
                // onKeyDown={handlesearch}
              />
            </div>*/}
          </div>
        </div>
        {data.length > 0 ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>mobilenumber</th>
                    <th>Create At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td className="user_name">
                          <img
                            src={item.image}
                            alt="profile"
                            className="data_userdetails_img"
                          />
                          {item.fullName}
                        </td>
                        <td>{item.email}</td>
                        <td>{item.mobilenumber}</td>

                        <td>{moment(item.createdAt).format("DD MMMYYYY")}</td>
                        <td>
                          <div style={{ width: "70px" }}>
                            <DeleteIcon
                              sx={{ color: "var(--red)" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setid(item.id);
                                setshowdelete(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination pagedata={pagination} onPageChange={getData} />
          </>
        ) : (
          <p className="nodata">No Submin</p>
        )}
      </div>
      {loading && <Loader />}
      <Deletepopup
        isOpen={showdelete}
        setisOpen={setshowdelete}
        handledelete={handledelete}
        onClose={onClose}
      />

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};
export default SubAdminList;
